module.exports = __webpack_public_path__ + "img/application.1e0c00a9.png";